// extracted by mini-css-extract-plugin
export default {"input":"OptionQCM_input__59ope","span":"OptionQCM_span__jt2rq"};